import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#4678bb",
      primaryHover: "#3e6ba9",
    },
    logoImage: logo,
    backend: "https://kataloge.verlagruhr.de/",
    directory: "/kiosk",
    header: {
      customer: "",
      title: "Unsere Kataloge online lesen – Verlag an der Ruhr",
      lineHeader: true,
    },
    accToolbar: true,
    info: [
      {
        text: 'Impressum',
        link: 'https://www.verlagruhr.de/Impressum'
      },
      {
        text: 'Datenschutz',
        link: 'https://www.verlagruhr.de/Datenschutz'
      },
      {
        text: 'AGB',
        link: 'https://www.verlagruhr.de/AGB'
      }
  ]
  };